module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-form-table', {
    staticClass: "project-table",
    attrs: {
      "form": _vm.form,
      "list": _vm.allProjects,
      "create": _vm.save,
      "update": _vm.update,
      "destroy": _vm.destroy,
      "translation": "table.projects"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dd55fab","hasScoped":false}!./src/app/components/projectTable/projectTable.html
// module id = 3054
// module chunks = 1